/* global allAttempts */
import * as d3 from 'd3'

import { hexbin } from 'd3-hexbin'

const data = allAttempts

const colorScale = d3
    .scaleLinear()
    .domain([0, 0.33, 0.7])
    .range(['#3661AD', '#ffffff', '#D82129'])
    .clamp(true)

function setTextColorWithBackground(color) {
    const { r, g, b } = color
    const colorValue = Math.round(
        (parseInt(r, 10) * 299 +
            parseInt(g, 10) * 587 +
            parseInt(b, 10) * 114) /
            1000
    )

    return colorValue > 125 ? '#000' : '#fff'
}

// Make variable
const $svgWrapper = document.getElementById('throwing-viz-svg-wrapper')
const svg = d3.select('#throwing-viz')

const is_3b_viz = document.getElementById('ddlTargetBase')?.value === '3B'

const size = 500
const margin = { top: 40, right: 50, bottom: 120, left: 70 }
const width = size - margin.left - margin.right
const height = size - margin.top - margin.bottom

function resizeSvgHeight() {
    const svgHeight = svg.node().getBoundingClientRect().height

    $svgWrapper.style.height = `${Math.min(svgHeight, 500)}px`
}

window.addEventListener('resize', resizeSvgHeight)

resizeSvgHeight()

// TODO: Hacky way of handling axis scaling for now, will need to rework once switching is on

let popDomain
let distDomain

if (is_3b_viz) {
    // There was no meaningful quantitative thought process into assigning these for now
    popDomain = [1.4, 1.8]
    distDomain = [40, 58]
} else {
    popDomain = [1.75, 2.25]
    distDomain = [48, 66]
}

// const popDomain = [1.75, 2.25]
const popScale = d3
    .scaleLinear()
    .domain(popDomain)
    .range([height, 0])
    .clamp(true)

// const distDomain = d3.extent(data, (d) => d.distance_to_target)

// const distDomain = [48, 66]
const distScale = d3
    .scaleLinear()
    .domain(distDomain)
    .range([0, width])
    .clamp(true)

const radius = 20
const hex = hexbin()
    .x((d) => distScale(d.dist))
    .y((d) => popScale(d.pop))
    .radius(radius)
// I can't figure out what this actually does
// .extent([
//     [0, 0],
//     [400, 400],
// ])

const g = svg
    .append('g')
    .attr('transform', `translate(${margin.left},${margin.top})`)

g.append('text')
    .attr('id', 'xLabel')
    // Have to nudge to ~230, 345
    .attr(
        'transform',
        `translate(${width / 2 + 35} ,${height + margin.bottom - 70})`
    )
    .style('text-anchor', 'middle')
    .style('font-size', '14px')
    .style('font-weight', 'bold')
    .attr('fill', '#3a9098')
    .text(`Runner Distance from ${is_3b_viz ? '3rd' : '2nd'}`)

g.append('text')
    .attr('id', 'yLabel')
    .attr('transform', 'rotate(-90)')
    .attr('y', 0 - margin.left + 12)
    .attr('x', 0 - height / 2)
    .attr('dy', '0em')
    .style('text-anchor', 'middle')
    .style('font-size', '14px')
    .style('font-weight', 'bold')
    .attr('fill', '#3a9098')
    .text('Pop Time (seconds)')

const bins = hex(data)

const binsData = bins.map((bin) => {
    const n = bin.length
    const n_cs = bin.filter((d) => d.is_cs).length
    const cs_rate = n_cs / n
    const mean_dist = d3.mean(bin, (d) => d.dist)
    const mean_pop = d3.mean(bin, (d) => d.pop)
    return {
        ...bin,
        n,
        n_cs,
        cs_rate,
        mean_dist,
        mean_pop,
    }
})

const lengthExtent = d3.extent(binsData, (d) => d.n)

const consistentRadius = false

const radiusScale = d3
    .scaleSqrt()
    .domain(lengthExtent)
    .range([radius / 8, radius - 1])

const $pop = document.getElementById('stat-pop-time')
const $dist = document.getElementById('stat-dist')
const $csRate = document.getElementById('stat-cs-rate')
const $attempts = document.getElementById('stat-attempts')

const pop = d3.mean(data, (d) => d.pop)
const dist = d3.mean(data, (d) => d.dist)
const csRate = d3.mean(data, (d) => d.is_cs)
const attempts = data.length

const explainerDepth = 105

const distExplainer = g
    .append('g')
    .attr('transform', `translate(0, ${height + explainerDepth})`)

const baseSize = 22

const basePathScale = d3.scaleLinear().domain([0, 90]).range([0, width])

const basePathWidth = 10

distExplainer
    .append('rect')
    .attr('x', 0)
    .attr('y', basePathWidth / -2)
    .attr('width', width)
    .attr('height', basePathWidth)
    .attr('fill', 'rgb(183, 208, 218)')

distExplainer
    .append('rect')
    .attr('x', basePathScale(distDomain[0]))
    .attr('y', basePathWidth / -2)
    .attr('width', basePathScale(distDomain[1]) - basePathScale(distDomain[0]))
    .attr('height', basePathWidth)
    .attr('fill', 'rgb(99, 161, 180)')

const firstBase = distExplainer
    .append('g')
    .style('perspective', '100px')
    .style('perspective-origin', 'center top')
    .append('g')
    .style('transform', 'rotateX(8deg)')

firstBase
    .append('rect')
    .attr('rx', baseSize / 10)
    .attr('x', width)
    .attr('y', -baseSize / 2)
    .attr('width', baseSize)
    .attr('height', baseSize)
    .attr('fill', '#fff')
    .attr('stroke', '#000')
    .attr('stroke-width', 1)

const secondBase = distExplainer
    .append('g')
    .style('perspective', '100px')
    .style('perspective-origin', 'center top')
    .append('g')
    .style('transform', 'rotateX(8deg)')

secondBase
    .append('rect')
    .attr('rx', baseSize / 10)
    .attr('x', -baseSize)
    .attr('y', -baseSize / 2)
    .attr('width', baseSize)
    .attr('height', baseSize)
    .attr('fill', '#fff')
    .attr('stroke', '#000')
    .attr('stroke-width', 1)

const lineGenerator = d3.line()

firstBase
    .append('text')
    .text(`${is_3b_viz ? '2B' : '1B'}`)
    .attr('x', width + baseSize / 2)
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('font-size', 10)

secondBase
    .append('text')
    .text(`${is_3b_viz ? '3B' : '2B'}`)
    .attr('x', -baseSize / 2)
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('font-size', 10)
distExplainer
    .append('path')
    .attr('stroke', '#666')
    .attr('stroke-width', 2)
    .attr('stroke-dasharray', '2 4')
    .attr(
        'd',
        lineGenerator([
            [basePathScale(0), -explainerDepth + 30],
            [basePathScale(distDomain[0]), -1],
        ])
    )
distExplainer
    .append('path')
    .attr('stroke', '#666')
    .attr('stroke-width', 2)
    .attr('stroke-dasharray', '2 4')
    .attr(
        'd',
        lineGenerator([
            [basePathScale(90), -explainerDepth + 30],
            [basePathScale(distDomain[1]), -1],
        ])
    )

// distExplainer
//     .append('path')
//     .attr('stroke', '#666')
//     .attr('stroke-width', 3)
//     .attr('transform', 'translate(0, 1)')
//     .attr(
//         'd',
//         lineGenerator([
//             [basePathScale(distDomain[1]), 0],
//             [basePathScale(distDomain[0]), 0],
//         ])
//     )

const fadedOpacity = 0.8
const runnerGroup = distExplainer
    .append('g')
    .attr('opacity', fadedOpacity)
    .attr('transform', `translate(${basePathScale(dist)}, 0)`)

runnerGroup
    .append('ellipse')
    .attr('rx', 7)
    .attr('ry', 2)
    .attr('fill', 'rgba(0, 0, 0, 0.5)')
    .attr('cx', 0)
    .attr('cy', 2)

runnerGroup
    .append('image')
    .attr('class', 'runner')
    .attr('href', `/sections/leaderboard/images/baserunner.png`)
    .attr('x', -30 + 3)
    .attr('y', -60 + 4)
    .attr('height', 60)

distExplainer
    .append('image')
    .attr('class', 'fielder')
    .attr('href', `/sections/leaderboard/images/fielder.png`)
    .attr('x', -30 + 14)
    .attr('y', -60 + 3)
    .attr('height', 60)

function resetStatValues() {
    $pop.querySelector('.throwing-stat-value').textContent = `${pop.toFixed(2)}`
    $dist.querySelector('.throwing-stat-value').textContent = `${dist.toFixed(
        0
    )}`
    $csRate.querySelector('.throwing-stat-value').textContent = `${Math.round(
        csRate * 100
    )}%`
    $attempts.querySelector('.throwing-stat-value').textContent =
        attempts.toLocaleString()

    d3.selectAll('.bg-hexagon').attr('fill', 'white')
    d3.selectAll('.actual-hexagon')
        .attr('stroke', '#c2c2c2')
        .attr('stroke-width', 1)

    $csRate.style.backgroundColor = 'rgba(255, 255, 255, 0.75)'
    $csRate.style.color = '#000'
}

resetStatValues()

function setStatValues(d, $hexEl, $bgHexEl) {
    $pop.querySelector(
        '.throwing-stat-value'
    ).textContent = `${d.mean_pop.toFixed(2)}`
    $dist.querySelector(
        '.throwing-stat-value'
    ).textContent = `${d.mean_dist.toFixed(0)}`
    $csRate.querySelector('.throwing-stat-value').textContent = `${(
        d.cs_rate * 100
    ).toFixed(0)}%`
    $attempts.querySelector('.throwing-stat-value').textContent = d.n

    d3.select($hexEl).attr('stroke-width', 2).attr('stroke', '#666')
    d3.select($bgHexEl).attr('fill', '#eeeeee')

    const color = colorScale(d.cs_rate)
    $csRate.style.backgroundColor = color
    $csRate.style.color = setTextColorWithBackground(d3.color(color))
}

const $gLegend = d3
    .select('#throwing-viz-legend')
    .append('g')
    .attr('transform', `translate(${2 * radius}, ${radius})`)

const maxHex = $gLegend.append('g')

maxHex
    .append('path')
    .attr('d', hex.hexagon(radius))
    .attr('fill', 'white')
    .attr('stroke', 'black')
    .attr('stroke-width', 1)

maxHex
    .append('text')
    .attr('y', 40)
    .attr('text-anchor', 'middle')
    .text(lengthExtent[1])

const midHex = $gLegend
    .append('g')
    .attr('transform', `translate(${2 * radius}, 0)`)

midHex
    .append('path')
    .attr('d', hex.hexagon(radiusScale(lengthExtent[1] / 2)))
    .attr('fill', 'white')
    .attr('stroke', 'black')
    .attr('stroke-width', 1)

midHex
    .append('text')
    .attr('y', 40)
    .attr('text-anchor', 'middle')
    .text(Math.round(lengthExtent[1] / 2))

const minHex = $gLegend
    .append('g')
    .attr('transform', `translate(${4 * radius}, 0)`)

minHex
    .append('path')
    .attr('d', hex.hexagon(radiusScale(1)))
    .attr('fill', 'white')
    .attr('stroke', 'black')
    .attr('stroke-width', 1)

minHex.append('text').attr('y', 40).attr('text-anchor', 'middle').text('1')

g.selectAll('g.hexagon')
    .data(binsData)
    .join((enter) => {
        const $g = enter
            .append('g')
            .attr('class', 'hexagon')
            .attr('transform', (d) => `translate(${d.x},${d.y})`)

        $g.append('path')
            .attr('class', 'bg-hexagon')
            .attr('d', hex.hexagon(radius))
            .attr('fill', 'rgba(255, 255, 255, 0.75)')
            .on('mouseover', (e, d) => {
                runnerGroup
                    .attr('opacity', 1)
                    .attr(
                        'transform',
                        `translate(${basePathScale(d.mean_dist)}, 0)`
                    )
                setStatValues(
                    d,
                    e.target.parentNode.querySelector('.actual-hexagon'),
                    e.target
                )
            })
            .on('mouseout', () => {
                runnerGroup
                    .attr('opacity', fadedOpacity)
                    .attr('transform', `translate(${basePathScale(dist)}, 0)`)
                resetStatValues()
            })

        $g.append('path')
            .attr('class', 'actual-hexagon')
            .attr('d', (d) =>
                hex.hexagon(consistentRadius ? radius : radiusScale(d.n))
            )
            .attr('fill', (d) => colorScale(d.cs_rate))
            .attr('stroke', '#c2c2c2')
            .attr('stroke-width', 1)
            .on('mouseover', (e, d) => {
                runnerGroup
                    .attr('opacity', 1)
                    .attr(
                        'transform',
                        `translate(${basePathScale(d.mean_dist)}, 0)`
                    )

                d3.select(e.target)
                    .attr('stroke-width', 2)
                    .attr('stroke', '#666')

                setStatValues(
                    d,
                    e.target,
                    e.target.parentNode.querySelector('.bg-hexagon')
                )
            })
            .on('mouseout', () => {
                runnerGroup
                    .attr('opacity', fadedOpacity)
                    .attr('transform', `translate(${basePathScale(dist)}, 0)`)
                resetStatValues()
            })

        return $g
    })

const nudgeDown = (radius * 3) / 4
const nudgeLeft = radius * 1.2

g.append('g')
    .attr('transform', `translate(0, ${height + nudgeDown})`)
    .call(
        d3
            .axisBottom(distScale)
            .ticks(4)
            .tickFormat((d) => `${d} ft`)
    )

g.append('g')
    .attr('transform', `translate(${0 - nudgeLeft}, 0)`)
    .call(d3.axisLeft(popScale))

const $explainerText = document.getElementById('throwing-explainer-text')

document
    .getElementById('throwing-viz-explainer-button')
    .addEventListener('click', () => {
        $explainerText.classList.toggle('hidden')
    })
